import { getLineChartConfig, DataSet } from '../getLineChartConfig';
import { generateColorRange } from '../chartsUtils';
import { EnterpriseData } from '../../entity.types';

export function getEvolutionLineChartConfig({
  oppositesEnterpriseDatas,
  enterpriseDatas,
  onChartClick,
}: {
  oppositesEnterpriseDatas: Array<EnterpriseData>;
  enterpriseDatas: EnterpriseData;
  onChartClick: (
    evt: MouseEvent,
    data: DataSet & {
      customMetadatas?: { raisonSociale: string; enterpriseId: string };
    },
    label: string,
  ) => void;
}) {
  const oppositeCasesColors = generateColorRange({
    baseH: 218,
    minSL: 20,
    maxSL: 80,
    nb: oppositesEnterpriseDatas.length,
  });

  const baseDatasetConfig = {
    borderWidth: 2,
    pointStyle: <const>'circle',
    pointRadius: 4,
    fill: false,
    pointHoverBorderWidth: 1,
    pointHoverRadius: 6,
  };

  const mainDatasetConfig = {
    ...baseDatasetConfig,
    label: `Nombre de décisions ${
      enterpriseDatas.raisonSociale
        ? `de ${enterpriseDatas.raisonSociale} `
        : ''
    }référencées `,
    backgroundColor: 'rgba(11, 166, 95, 0.1)',
    borderColor: 'rgb(11, 166, 95)',
    fill: true,
  };

  const mainLength = enterpriseDatas.chronology.caseData.years.length;

  const datasets = [
    // we use slice to not display the last element because we want to display it with a border dash
    {
      ...mainDatasetConfig,
      customMetadatas: {
        raisonSociale: enterpriseDatas.raisonSociale,
        enterpriseId: enterpriseDatas.enterpriseId,
      },
      data: enterpriseDatas.chronology.caseData.caseCounts.slice(0, -1),
    },
    {
      // in order to display the last part of the chart with the border dash, we build another section of the chart on the specific indexes
      ...mainDatasetConfig,
      customMetadatas: {
        raisonSociale: enterpriseDatas.raisonSociale,
        enterpriseId: enterpriseDatas.enterpriseId,
      },
      data: [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {
          x: enterpriseDatas.chronology.caseData.years[mainLength - 2],
          y: enterpriseDatas.chronology.caseData.caseCounts[mainLength - 2],
        },
        {
          x: enterpriseDatas.chronology.caseData.years[mainLength - 1],
          y: enterpriseDatas.chronology.caseData.caseCounts[mainLength - 1],
        },
      ],
      borderDash: [5, 5],
    },
    ...oppositesEnterpriseDatas.map((oppositeCasesData, i) => ({
      ...baseDatasetConfig,
      data: oppositeCasesData.chronology.caseData.caseCounts.slice(0, -1),
      label: `Nombre de décisions référencées de ${oppositeCasesData.raisonSociale} `,
      customMetadatas: {
        raisonSociale: oppositeCasesData.raisonSociale,
        enterpriseId: oppositeCasesData.enterpriseId,
      },
      backgroundColor: oppositeCasesColors[i],
      borderColor: oppositeCasesColors[i],
    })),
    ...oppositesEnterpriseDatas.map((oppositeCasesData, i) => {
      const caseDataTemp = oppositeCasesData.chronology.caseData;
      const { length } = caseDataTemp.years;
      return {
        // same here for the opposite enterprises
        ...baseDatasetConfig,
        data: [
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {
            x: caseDataTemp.years[length - 2],
            y: caseDataTemp.caseCounts[length - 2],
          },
          {
            x: caseDataTemp.years[length - 1],
            y: caseDataTemp.caseCounts[length - 1],
          },
        ],
        label: `Nombre de décisions référencées de ${oppositeCasesData.raisonSociale} `,
        backgroundColor: oppositeCasesColors[i],
        borderColor: oppositeCasesColors[i],
        borderDash: [5, 5],
        customMetadatas: {
          raisonSociale: oppositeCasesData.raisonSociale,
          enterpriseId: oppositeCasesData.enterpriseId,
        },
      };
    }),
  ];

  return getLineChartConfig({
    datasets,
    labels: enterpriseDatas.chronology.caseData.years.map(item => String(item)),
    onChartClick,
  });
}
